import React from 'react';

interface TableRowData {
  label: string;
  content?: React.ReactNode;
}

interface TableBodyProps {
  rows: TableRowData[];
}

const TableBody: React.FC<TableBodyProps> = ({ rows }) => {
  return (
    <div className="rounded-lg bg-grayBox">
      <table className="w-full border-collapse leading-[1.2]">
        <tbody>
          {rows.map((row, index) => (
            // <tr
            //   key={index}
            //   /* 마지막 행이 아닐 때만 하단 테두리(border-b) 추가 */
            //   className={index !== rows.length - 1 ? 'border-b border-lineBorder' : ''}
            // >
            //   <td className="line-clamp-1 w-[140px] content-center py-[20px] pl-[20px] text-left align-middle text-base font-medium leading-[26px] text-white">
            //     {row.label}
            //   </td>
            //   <td className="py-[20px] pr-[20px] text-right align-middle text-sm font-medium leading-[17px] text-contentText">
            //     {row.content || '-'}
            //   </td>
            // </tr>

            <tr
              key={index}
              /* 마지막 행이 아닐 때만 하단 테두리 추가 */
              className={`group ${index !== rows.length - 1 ? 'border-b border-lineBorder' : ''}`}
            >
              <td className="w-[140px] py-[20px] pl-[20px] text-left align-middle text-base font-medium leading-[26px] text-white">
                {/* label 영역: line-clamp-1은 div로 감싸는 것이 안전합니다 */}
                <div className="line-clamp-1">{row.label}</div>
              </td>
              <td className="py-[20px] pr-[20px] text-right align-middle text-sm font-medium leading-[17px] text-contentText">
                {row.content || '-'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TableBody;
